module.exports = __webpack_public_path__ + "static/media/logo.63a6d322.svg";